import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/** @jsx jsx */


import { jsx } from 'theme-ui';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default (function (props) {
  return jsx("footer", _extends({}, props, {
    sx: {
      position: 'absolute',
      zIndex: 1,
      left: 0,
      bottom: 0,
      right: 0,
      pointerEvents: 'none',
      variant: 'styles.Footer'
    }
  }));
});